<!--
 * @Author: Ztq
 * @Date: 2022-06-15 16:57:55
 * @LastEditors: luckymiaow
 * @LastEditTime: 2022-10-12 15:00:09
 * @Description: 
 * @FilePath: \ch2-template-vue\src\components\common\text-ellipsis\TextEllipsis.vue
-->
<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';

interface Props {
  value: string;
  maxWidth?: string;
  lineHeight?: string;
  minHeight?: number;
  justifyContent?: string;
  showIcon?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  value: '',
  lineHeight: '40px',
  maxWidth: '400px',
  minHeight: 40,
  justifyContent: 'center',
  showIcon: false,
});

const textStyle = ref({
  height: `${props.minHeight}px`,
  lineHeight: props.lineHeight,
  overflow: 'hidden',
});

const txtType = ref();

const hideText = ref(false);

function lookmore() {
  hideText.value = !hideText.value;
}

function init() {
  nextTick(() => {
    // 通过ref获取对应dom节点的高度，注意minHeight为显示时的高度
    let hei = txtType.value.clientHeight;
    // 当获取的高度大于minHeight时，即当前文本为多行，设置添加收起文本的class，
    // 当获取的高度等于minHeight时，隐藏查看更多按钮
    if (hei >= props.minHeight) {
      hideText.value = true;
    } else if (hei < props.minHeight) {
    }
  });
}

onMounted(() => {
  init();
});
</script>

<template>
  <div class="info" :style="{ width: maxWidth }">
    <p ref="txtType" :style="hideText ? textStyle : { lineHeight: `${lineHeight}px` }" @click.stop="lookmore()">
      {{ value }}
    </p>
    <component
      :is="hideText ? 'DownOutlined' : 'UpOutlined'"
      v-if="showIcon"
      :style="{ lineHeight, color: '#1890ff', marginLeft: '2px ' }"
      @click.stop="lookmore()"
    />

    <a v-else :style="{ whiteSpace: 'nowrap', fontSize: '10px', lineHeight }" @click.stop="lookmore()">{{
      hideText ? '展开' : '收起'
    }}</a>
  </div>
</template>

<style scoped lang="less">
// .txttype {
//   letter-spacing: 0.5px;
//   line-height: 30px;
//   position: relative;
// }
// .hidetext {
//   position: relative;
//   //   height: v-bind(props.lineHeight) + 'px';
//   height: 25px;
//   overflow: hidden;
//   span {
//     display: block;
//   }
// }
// .spanp {
//   display: flex;
//   cursor: pointer;
//   // justify-content: center;
// }

.info {
  display: flex;
  cursor: pointer;
  .text-show {
    height: 30px;
    overflow: hidden;
  }
  .text-hidden {
  }
}
</style>
